import {
    POST,
    GET
} from "../util";
const currencyUrl = "api​/currency/";
const url = {
    list: `${currencyUrl}list`,
    listEnabled: 'api/currency/listEnabled?forProspectiveUpload=:forProspectiveUpload',
    currencyExchangeRates: "api/admin/currencyexchange/list/latest"
};
const currencyApi = {
    List: (params = {}) => {
        return GET(url.list, params);
    },
    ListEnabled: (forProspectiveUpload= false) => {
        return GET(url.listEnabled.replace(":forProspectiveUpload", forProspectiveUpload), {}, false);
    },
    getCurrencyExchangeRates: () => {
        return GET(url.currencyExchangeRates);
    }
};
export {
    currencyApi
};